export var AnalyticsType;
(function (AnalyticsType) {
    AnalyticsType["GTM"] = "GTM";
    AnalyticsType["MO_ENGAGE"] = "MO_ENGAGE";
    AnalyticsType["BRAZE"] = "BRAZE";
    AnalyticsType["AMPLITUDE"] = "AMPLITUDE";
    AnalyticsType["FBQ"] = "FBQ";
    AnalyticsType["TAPFILIATE"] = "TAPFILIATE";
    AnalyticsType["LOG_ROCKET"] = "LOG_ROCKET";
    AnalyticsType["RUDDER_STACK"] = "RUDDER_STACK";
})(AnalyticsType || (AnalyticsType = {}));
export var PageType;
(function (PageType) {
    PageType["TEMPLATES"] = "Templates Page";
    PageType["VIDEOWALL"] = "Videowall Page";
    PageType["TOOLS"] = "Tools Page";
    PageType["HOMEPAGE"] = "Homepage";
    PageType["MAKE"] = "Make Page";
    PageType["BLOG"] = "Blog Page";
    PageType["TERMS_AND_POLICY"] = "Terms and Policy Page";
    PageType["CREATOR_PAGE"] = "Creator Page";
    PageType["SIGNUP_PAGE"] = "Signup Page";
    PageType["PRICING_PAGE"] = "Pricing Page";
    PageType["CHECKOUT"] = "Checkout Page";
    PageType["ACCOUNT_PAGE"] = "Account Page";
    PageType["AI"] = "AI";
    PageType["UPDATE_PAYMENT_DETAILS"] = "Update Payment Details Page";
})(PageType || (PageType = {}));
